import React from 'react';

import CustomerTabs from './customerTab';
import CustomerSearchAppBar from 'src/components/VemigoSearchBar/customerSearchBox';
import { BasicInfoService } from 'src/services/customer/baiscInfoService';
import { useCustomerBookingCart } from './selectedCustomerData';
import { AddBooking } from './customerBookingCart/addBooking';
import { CustomerBookingCart } from './customerBookingCart';
import AddCustomer from '../subscriptions/addCustomer';

const CustomerBookingPageLayout = () => {
  const { selectedCustomerData, setSelectedCustomer } =
    useCustomerBookingCart();
  const [selectPage, setSelectPage] = React.useState('');
  const [searchResults, setSearchResults] = React.useState([]);

  const searchData = async (text) => {
    if (text.length >= 3) {
      const data = await BasicInfoService.findCustomers(text);
      setSearchResults(data);
    } else {
      setSearchResults([]);
    }
  };

  const handleCustomerSelect = async (id: number) => {
    try {
      const fullData = await BasicInfoService.getCustomerById(id);
      setSelectedCustomer(fullData);
      setSelectPage('RCData');
    } catch (error) {
      console.error('Failed to fetch customer by id', error);
    }
  };


  const passData = (data) => {
    if (data.length !== 0) {
      setSelectPage('RCData');
      setSelectedCustomer(data);
    }
  };

  const handleCustomerCreated = (newCustomer) => {
    setSelectedCustomer(newCustomer);
    setSelectPage('RCData'); 
  };

  const handleButtonClick = () => {
    setSelectPage('addPage');
  };

  const handleCloseAddCustomer = () => {
    setSelectPage('');
  };

   const pageValueChange = (changeValue: boolean) => {
    if (changeValue) {
      setSelectPage('RCData');
    }
  };


  return (
    <>
      <CustomerSearchAppBar
        buttonText="+ Add Customer"
        addPageClick={handleButtonClick}
        searchData={searchData}
        data={selectedCustomerData}
        setSelectedPage={setSelectPage}
        searchResults={searchResults}
        handleCustomerSelect={handleCustomerSelect}
      />

      {selectPage === 'addPage' ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: 'white',
            margin: '3% 3% 0 3%',
            padding: '3%',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
           <AddCustomer
          open={true}
          label="ADD CUSTOMER"
          description="Enter Customer Details"
          addBtn="ADD CUSTOMER"
          handleClose={handleCloseAddCustomer}
          handleSaveData={pageValueChange}
        />
        </div>
      ) : selectPage === 'RCData' ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: 'white',
            margin: '3%',
            padding: '3%',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
          <CustomerBookingCart
            onBookingSuccess={() => {
              setSelectPage('');
              setSelectedCustomer(null);
            }}
            onBack={() => {
              setSelectPage('');
              setSelectedCustomer(null);
            }}
          />
        </div>
      ) : null}

    </>
  );
};

export default CustomerBookingPageLayout;
